import type { ReactNode } from "react";
import { ScanFace, ShieldAlert } from "lucide-react";
import type { DeviceCapabilitiesResponse } from "@centro-cirurgico/contracts";
import { Brand } from "@centro-cirurgico/ui";

import { hasFacialCapability } from "../hooks/useCapabilities";

interface HeaderProps {
  hospital: string;
  sector?: string | undefined;
  room: string;
  capabilities: DeviceCapabilitiesResponse | null;
  /** Ações extras à direita (ex.: voltar para a leitura de pulseira). */
  actions?: ReactNode;
}

/** Cabeçalho do totem facial (1.6): marca, unidade/setor/sala e pílula "Monitoramento ativo". */
export function Header({ hospital, sector, room, capabilities, actions }: HeaderProps) {
  const facialEnabled = hasFacialCapability(capabilities?.capabilities);
  const context = sector ? `${hospital} · ${sector}` : hospital;

  return (
    <header className="app-header">
      <div className="header-row">
        <Brand tag="TOTEM DE ACESSO" />
        <div className="hospital-info">
          <span className="hospital-name">{room}</span>
          <span className="room-info">{context}</span>
        </div>
        {actions}
        <span className={`status-pill ${facialEnabled ? "ok" : "danger"}`} role="status">
          {facialEnabled ? <ScanFace aria-hidden="true" size={16} /> : <ShieldAlert aria-hidden="true" size={16} />}
          {facialEnabled ? "Monitoramento ativo" : "Reconhecimento indisponível"}
        </span>
      </div>
    </header>
  );
}
